import { Box, Center, Flex, SimpleGrid } from "@chakra-ui/react";
import deburr from "lodash.deburr";
import sortBy from "lodash.sortby";
import { NextPage } from "next";
import Link from "next/link";

import { Column, Heading, Index } from "./styles";

interface DesignerListData {
  __typename: string;
  id: string;
  name: string;
  slug: string;
}

// create regex function to check if A-Z
const letterRegexTest = (x: string) => /[a-zA-Z]/.test(x);

export const DesignerIndexView: NextPage = ({ data }) => {
  const items = data.other[0].values as DesignerListData[];

  const lettersObject = "#ABCDEFGHIJKLMNOPQRSTUVWXYZ"
    .split("")
    .reduce((acc, letter) => {
      acc[letter] = [];
      return acc;
    }, {});

  items.forEach((a) => {
    const firstLetter = a.name.trim().slice(0, 1).toUpperCase();
    if (letterRegexTest(firstLetter)) {
      if (!lettersObject[firstLetter]) {
        lettersObject["#"].push(a);
      } else {
        lettersObject[firstLetter].push(a);
      }
    } else {
      try {
        const letterDeburr = deburr(firstLetter);

        if (!lettersObject[letterDeburr]) {
          lettersObject["#"].push(a);
        } else {
          lettersObject[letterDeburr].push(a);
        }
      } catch (e) {
        lettersObject["#"].push(a);
      }
    }
  });

  const objectKeys = Object.keys(lettersObject).filter(
    (a) => lettersObject[a].length > 0
  );

  objectKeys.forEach((k) => {
    lettersObject[k] = sortBy(lettersObject[k], "name");
  });

  const boxes = objectKeys.map((x) => (
    <Box maxW="xs" key={x}>
      <a id={x} name={x}>
        <br />
        <br />
        <Heading>{x}</Heading>
        <SimpleGrid columns={2}>
          {lettersObject[x].map((y: DesignerListData) => (
            <Column>
              <Link
                prefetch={false}
                href={`/designers/${
                  y.slug.endsWith("-hire") ? y.slug : y.slug.concat("-hire")
                }`}
              >
                {y.name}
              </Link>
            </Column>
          ))}
        </SimpleGrid>
      </a>
    </Box>
  ));

  const indexes = objectKeys.map((x) => (
    <Box key={x}>
      <Index href={`#${x}`}>{x}</Index>
    </Box>
  ));

  return (
    <Box padding="20px">
      <Flex direction="column">
        <Center>
          <h1>{data.article.title}</h1>
        </Center>
        <br />
        <span>{JSON.parse(data.article.content)?.blocks?.[0]?.data?.text}</span>
      </Flex>
      <br />
      <SimpleGrid minChildWidth="30px" spacing="5px">
        {indexes}
      </SimpleGrid>
      <br />
      <SimpleGrid minChildWidth="400px" spacing="20px">
        {boxes}
      </SimpleGrid>
    </Box>
  );
};
